import getDefaultTopTen from './getDefaultTopTen';
import getLeadearboardWithUserInfo from './getLeaderboardWithUserInfo';
import { ScoreFragment } from '@/shared/graphql/ScoreFragment.generated';
import { MyScoreFragment } from '@/shared/graphql/TournamentFragment.generated';

const getDetailedLeaderboardList = (
  myScore?: MyScoreFragment,
  leaderboard?: ScoreFragment[],
) => {
  const {
    position,
    leaderboardBefore = [],
    leaderboardAfter = [],
  } = myScore || {};
  const isLast = !leaderboardAfter.length;
  const iAmInTopTen = position ? position < 10 : false;

  if (iAmInTopTen) {
    return getDefaultTopTen(leaderboard);
  }

  return getLeadearboardWithUserInfo({
    leaderboard,
    leaderboardAfter,
    leaderboardBefore,
    isLast,
    myScore,
  });
};

export default getDetailedLeaderboardList;
